<template>
  <div>
    <loading v-show="showLoading"></loading>
    <div class="withdraw" ref="wrapper" v-show="!showLoading">
      <ul ref="ul">
        <slot name="pulldown"
          :pullDownRefresh="pullDownRefresh"
          :pullDownStyle="pullDownStyle"
          :beforePullDown="beforePullDown"
          :isPullingDown="isPullingDown"
          :bubbleY="bubbleY"
        >
          <div ref="pulldown" class="pulldown-wrapper" :style="pullDownStyle" v-if="pullDownRefresh">
            <div class="before-trigger" v-if="beforePullDown">
              <bubble :y="bubbleY"></bubble>
            </div>
            <div class="after-trigger" v-else>
              <div class="loading" v-if="isPullingDown">
                <loading></loading>
              </div>
              <div class="loading-success" v-else>
                <span>{{refreshTxt}}</span>
              </div>
            </div>
          </div>
        </slot>
        <li v-for="(item, index) of withdrawList" :key="index">
          <blanking></blanking>
          <div class="item-wrapper">
            <div class="item-header-wrapper border-1px">
              <span class="item-name">Debit</span>
              <span class="item-time">{{item.withdrawTime}}</span>
            </div>
            <div class="item-content-wrapper">
              <div class="content-status">
                <div class="type">
                  <span>Memo: Power by better-scroll</span>
                </div>
                <div class="status-success" v-if="item.status == 1">
                  Successed
                </div>
                <div class="status-fail" v-if="item.status == 2">
                  Failure
                </div>
              </div>
              <div class="content-value">
                <span class="number">
                  -{{item.amount}}
                </span>
                <span class="orderid">
                  Order ID: {{item.orderId}}
                </span>
              </div>
            </div>
          </div>
        </li>
        <div class="pullup-wrapper" v-show="showPullUpLoad">
          <div class="no-more" v-show="!isPullUpLoad">
            <span>{{pullUpText}}</span>
          </div>
          <div v-show="isPullUpLoad">
            <loading></loading>
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import Loading from '@/base-component/loading'
import Blanking from '@/base-component/blanking'
import BScroll from 'better-scroll'
import Bubble from '@/base-component/bubble'
import { getOutList } from '@/api'
export default {
  name: 'Out',
  components: {
    Loading,
    Blanking,
    Bubble
  },
  data() {
    return {
      pullDownRefresh: true,
      pullDownStyle: {},
      beforePullDown: true,
      isPullingDown: false,
      bubbleY: 0,
      refreshTxt: '加载成功',
      pullDownInitTop: -50,
      // 是否显示头部loading
      showLoading: true,
      // list 数据
      withdrawList: [],
      // 是否有下一页（0没有，1有）
      hasNext: 0,
      refreshDelay: 20,
      // 显示上拉loading还是上拉文字
      isPullUpLoad: true,
      // 是否显示底部 pullup 部分
      showPullUpLoad: false,
      pullUpText: '没有更多数据了'
    }
  },
  methods: {
    _initScroll() {
      if(!this.$refs.wrapper) {
        return
      }
      this.scroll = new BScroll(this.$refs.wrapper, {
        scrollY: true,
        click: true,
        pullUpLoad: {
          threshold: 50
        },
        pullDownRefresh: {
          threshold: 60,
          stop: 0
        }
      })
      this._initPullDownRefresh()
      this._initPullUpLoad()
    },
    _initPullDownRefresh() {
      this.scroll.on('pullingDown', () => {
        this.beforePullDown = false
        this.isPullingDown = true
        this.$refs.ul.style.paddingTop = `50px`
        getOutList(0).then((resp) => {
          this.showLoading = false
          if(resp.code === 0) {
            this.index = 1
            this.hasNext = resp.next
            this.withdrawList = resp.withdrawList
            this.isPullingDown = false
            setTimeout(() => {
              this.beforePullDown = true
              this.$refs.ul.style.paddingTop = `0`
              this.$refs.ul.style.transition = `all .3s ease-out`
              this.scroll.finishPullDown()
            }, 1000)
          } else {
            this.beforePullDown = true
            this.$refs.ul.style.paddingTop = `0`
            this.$refs.ul.style.transition = `all .3s ease-out`
            this.scroll.finishPullDown()
          }
        })
      })
      this.scroll.on('scroll', (pos) => {
        if(!this.pullDownRefresh) {
          return
        }
        if(this.beforePullDown) {
          this.bubbleY = Math.max(0, pos.y + this.pullDownInitTop)
          this.pullDownStyle = `top:${Math.min(-pos.y, pos.y * 0.1 + this.pullDownInitTop)}px`
        } else {
          this.bubbleY = 0
          this.pullDownStyle = `top:${Math.min(-pos.y * 0.6, 0)}px`
        }
      })
    },
    _initPullUpLoad() {
      this.scroll.on('pullingUp', () => {
        this.showPullUpLoad = true
        this.refresh()
        if(this.hasNext === 1) {
          this.isPullUpLoad = true
          // this.refresh()
          getOutList().then((resp) => {
            if(resp.code === 0) {
              this.hasNext = resp.next
              this.withdrawList = this.withdrawList.concat(resp.withdrawList)
            }
            this.scroll.finishPullUp()
          })
        } else {
          this.isPullUpLoad = false
          this.scroll.finishPullUp()
          this.refresh()
        }
      })
    },
    refresh() {
      this.scroll && this.scroll.refresh()
    },
    destroy() {
      this.scroll.destroy()
    }
  },
  watch: {
    withdrawList() {
      setTimeout(() => {
        this.scroll.refresh()
      }, this.refreshDelay)
    }
  },
  created() {
    getOutList().then((resp) => {
      this.showLoading = false
      if(resp.code === 0) {
        this.hasNext = resp.next
        this.withdrawList = resp.withdrawList
      } else {

      }
    })
  },
  mounted() {
    setTimeout(() => {
      this._initScroll()
    }, this.refreshDelay)
  },
  destroy() {
    this.destroy()
  }
}
</script>
<style scoped lang='stylus'>
  @import "~@/style/mixin.styl"
  @import '~@/style/variable.styl'
  .withdraw
    position absolute
    top 92px
    width 100%
    bottom 0
    overflow: hidden
    .pulldown-wrapper
      position absolute
      top -50px
      width 100%
      left 0
      display flex
      justify-content center
      align-items center
      transition all
      .after-trigger
        .loading-success
          margin-top 20px
    ul
      list-style none
      margin 0
      padding-left 0
      li
        .item-wrapper
          .item-header-wrapper
            height 25px
            padding 12px 0
            border-1px($color-gray-l)
            .item-name
              display inline-block
              height 100%
              line-height 1.5
              padding-left 3%
              color $color-black
              font-size 18px
              border-left 4px solid $color-red
            .item-time
              display inline-block
              height 100%
              line-height 1.5
              float right
              margin-right 4.2%
              color $color-gray
              font-size 16px
          .item-content-wrapper
            padding 5% 4.2%
            .content-status
              height 40px
              .type
                display inline-block
                height 100%
                line-height 1.8
                color $color-gray
              .status-success
                display inline-block
                float right
                width 70px
                text-align center
                padding 8px
                font-size 14px
                color $color-green
                border 1px solid $color-green
                border-radius 4px
              .status-fail
                display inline-block
                float right
                width 70px
                text-align center
                padding 8px
                font-size 14px
                color $color-red
                border 1px solid $color-red
                border-radius 4px
            .content-value
              position relative
              margin-top 2%
              .number
                margin-left -5px
                color $color-red
                font-size 38px
              .orderid
                position absolute
                right 0
                bottom 10px
                color $color-gray
      .pullup-wrapper
        .no-more
          padding 10px 0
          text-align center
          border-top 1px solid $color-gray-l
</style>



// WEBPACK FOOTER //
// src/components/Out.vue